import React from "react";
import FaBell from "./icons/FaBell";
import FaFlag from "./icons/FaFlag";
import FaHeart from "./icons/FaHeart";
import FaPaw from "./icons/FaPaw";
import FaPlane from "./icons/FaPlane";
import FaRegFutbol from "./icons/FaRegFutbol";
import FaSmile from "./icons/FaSmile";
import FaUtensils from "./icons/FaUtensils";
const getEmojiGroups = (t) => [
  {
    title: t("EmojiPlugin_EmojiGroups_People"),
    icon: /* @__PURE__ */ React.createElement(FaSmile, null),
    category: "people",
    top: 948
  },
  {
    title: t("EmojiPlugin_EmojiGroups_Nature"),
    icon: /* @__PURE__ */ React.createElement(FaPaw, null),
    category: "nature",
    top: 1937
  },
  {
    title: t("EmojiPlugin_EmojiGroups_Food"),
    icon: /* @__PURE__ */ React.createElement(FaUtensils, null),
    category: "food",
    top: 2453
  },
  {
    title: t("EmojiPlugin_EmojiGroups_Activity"),
    icon: /* @__PURE__ */ React.createElement(FaRegFutbol, null),
    category: "activity",
    top: 2497
  },
  {
    title: t("EmojiPlugin_EmojiGroups_Travel"),
    icon: /* @__PURE__ */ React.createElement(FaPlane, null),
    category: "travel",
    top: 3485
  },
  {
    title: t("EmojiPlugin_EmojiGroups_Objects"),
    icon: /* @__PURE__ */ React.createElement(FaBell, null),
    category: "objects",
    top: 4603
  },
  {
    title: t("EmojiPlugin_EmojiGroups_Symbols"),
    icon: /* @__PURE__ */ React.createElement(FaHeart, null),
    category: "symbols",
    top: 6280
  },
  {
    title: t("EmojiPlugin_EmojiGroups_Flags"),
    icon: /* @__PURE__ */ React.createElement(FaFlag, null),
    category: "flags",
    top: 1e4
  }
];
const DEFAULT_CONFIG = {};
export {
  DEFAULT_CONFIG,
  getEmojiGroups
};
//# sourceMappingURL=constants.js.map
